<script>
	import Intro from './Intro.svelte';
	import Summary from './Summary.svelte';
	import Yesterday from './Yesterday.svelte';
	import Overview from './Overview.svelte';
	import Title from './Title.svelte';
	import Sources from './Sources.svelte';
	import Footer from './Footer.svelte';
	import Calendar from './Calendar.svelte';
	import Topics from './Topics.svelte';
	import Relations from './Relations.svelte';
</script>

<main>
	<div class="container">
		<Intro />
		<Title />
		<Summary />
		<Overview />
		<Yesterday />
		<Topics />
		<Relations />
		<Calendar />
		<Sources />
		<Footer />
	</div>
</main>

<style>
	.container {
		display: block;
		height: auto;
		position: relative;
		width: 100%;
	}
</style>